// 初期表示
export const PAGE_INIT = "industry/scale/PAGE_INIT";
// 検索結果でリクエスト
export const INDUSTRY_SCALE_GET = "industry/scale/INDUSTRY_SCALE_GET";
